<template>
  <v-dialog
      v-model="showDialog"
      persistent
      max-width="320"
    >

    <template v-slot:activator="{ props }">
      <div v-bind="props" data-cy="">
        <slot></slot>
      </div>
    </template>


    <v-card data-cy="d">
      <v-card-title class="dialog-title d-flex justify-space-between">
        <span>
          {{$t('routes.pod.fileArchived')}}
        </span>

        <v-btn icon @click="closeAndRedirect()" :aria-label="$t('common.close')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        {{$t('routes.pod.OKforRedirectToParent')}}
      </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="closeAndRedirect()" data-cy="">{{$t('common.redirect')}}</v-btn>
        </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { usePodStore } from '@/stores/PodStore.js';
import { useNodeStore } from '@/stores/NodeStore.js';
import DialogActionKeys from '@/components/mixin/DialogActionKeys.js';

export default {
  emits: ["input"],
  mixins: [DialogActionKeys],
  name: "PodArchivedDialog",

  props: {
    shouldShowArchivedPodDialog: {
      type: Boolean,
      required: true
    }
  },

  data: function() {
    return {

    };
  },

  methods: {
    closeAndRedirect: function() {
      const nodeStore = useNodeStore();
      const node = nodeStore.getCurrentNode;

      const podStore = usePodStore();
      podStore.setViewPodArchived(false);

      if (node && node.archived) {
          this.$router.push("/");
      } else {
          this.$router.push(`/node/${node.id}`);
      }
    }
  },

  computed: {
    showDialog: {
      get () {
        return this.shouldShowArchivedPodDialog;
      },
      set (value) {
         this.$emit('input', value);
      }
    }
  }
};
</script>

<style>

</style>
